export default __webpack_public_path__ + "static/media/au.6734a27a.svg";